import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import GitMergeIcon from "@redotech/redo-icons/git-merge_filled.svg";
import { BooleanFilterOperator } from "@redotech/redo-views-common/advanced-filters/boolean-filter";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.autoMergeDisabled;

export const AutoMergeDisabledFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: GitMergeIcon,
  displayName: entry.displayName,
  label: "Auto-merge",
  boolDisplay: { falseDisplay: "enabled", trueDisplay: "disabled" },
};
